import React, { useState, useEffect, useMemo } from 'react'
import lodash from 'lodash'
import styled from 'styled-components'

import { FormRow, Col } from '../../../../../../../1stlog-ui/src/components/Bootstrap'
import { useField, FeedbackBadge } from '../../../../../../../1stlog-ui/src/components/Field'

const validate = (value) =>
  value
    ? i18n.t(
        'error_hazmat_overload',
        'Gewicht der Gefahrgüter darf das Gesamtgewicht nicht überschreiten'
      )
    : undefined

const Weight = (props) => {
  const { hazmats } = props

  const weight = useField('weight')

  const {
    input: { value: isWeightInvalid, onChange: setIsWeightInvalid },
    meta
  } = useField('validation.isWeightInvalid', {
    raw: true,
    validate,
    subscribeAll: true
  })

  useEffect(() => {
    const hazmatWeight = lodash.sum(
      lodash.map(hazmats, (hazmat) => {
        const { count = 1, amount = 0, unit } = hazmat
        // dont count units other than kg towards total weight
        if (unit !== 'kg') {
          return null
        }
        return count * amount
      })
    )
    const newIsWeightInvalid = hazmatWeight > weight
    if (!lodash.isEqual(isWeightInvalid, newIsWeightInvalid)) {
      setIsWeightInvalid(newIsWeightInvalid)
    }
  }, [weight, hazmats])

  return (
    isWeightInvalid && (
      <FormRow>
        <Col>
          <FeedbackBadge meta={meta} />
        </Col>
      </FormRow>
    )
  )
}

export default Weight
